const pricingCompareLoader = () => {
  //  Seperate features of sprout plan.
  let _comparisonRates;
  let _competitorName = jQuery('.comparison-price-wrapper .comparison-price-widget.other-pricing > img').data('competitor-name');
  let _competitorIntegrationTypes = [];
  let _fsIntegrationTypes = [];
  let agentCount = 10;
  let _fsPricing = [];
  let _competitorPricing = [];
  let _fsFeaturesKeys = [];
  let _competitorFeaturesKeys = [];
  let _totalIntegrationPrice = 0;
  let _integrationLength = 0;
  let _fsIntegrationLength = 0;
  let freshsalesPlan = [];

  /** Utils Functions **/
  // compute max value in an array.
  const mathMax = (array) => {
    return (array.length > 0 ? Math.max.apply(Math, array) : 0);
  };

  // function to get the Sprout features name
  const filterByProperty = (array) => {
    let filtered = [];
    for (var i = 0; i < array.length; i++) {
      let obj = array[i];
      for (var key in obj) {
        if (obj[key]['price'] === 0) {
          filtered.push(key);
        }
      }
    }
    return filtered;
  };

  //  Init UI and click methods.
  const initUI = ($ = jQuery) => {
    // Deactivating the older click functions
    jQuery('.feature-comparison-widget').off('click');

    // Activating click events.
    jQuery('.feature-comparison-widget').on('click', function (ev) {
      if (!jQuery(this).hasClass('disabled')) {
        ev.preventDefault();
        jQuery(this).toggleClass('active');
        let featureName = jQuery(this).data('feature');
        let _hasClassActive = (jQuery(this).hasClass('active'));
        // compute the price of competitor;
        computePrice(_hasClassActive, featureName, _hasClassActive);
        modifyUIValues();
        //  Overriding Competitor Pricing along with Integration Price
        jQuery('.vs-numb').html((mathMax(_competitorPricing) * agentCount) + _totalIntegrationPrice);
      }
    });
  };

  // Compute Price of Freshsales and Competitor
  const computePrice = (add, featureName, _hasClassActive) => {
    let competitorData = _comparisonRates[_competitorName];
    let freshsalesData = _comparisonRates['freshsales'];
    let freshsalesPrice = freshsalesData[featureName]['price'];

    if (competitorData.hasOwnProperty(featureName)) {
      competitorIntegrationPrice(competitorData, featureName, _hasClassActive);
      let competitorPrice = competitorData[featureName]['price'];
      computeFreshsalesIntegrations(freshsalesData, featureName, _hasClassActive);
      if (add) {
        _fsPricing.push(freshsalesPrice);
        _competitorPricing.push(competitorPrice);
      } else {
        _fsPricing.splice(_fsPricing.indexOf(freshsalesPrice), 1);
        _competitorPricing.splice(_competitorPricing.indexOf(competitorPrice), 1);
      }
    }
  };

  //  Compute Freshsales Integration and add to its count if any
  const computeFreshsalesIntegrations = (freshsalesData, featureName, _hasClassActive) => {
    let isIntegration = (freshsalesData[featureName]['integrations']) ? (freshsalesData[featureName]['integrations'] === true) : false;
    // let integrationPrice = (freshsalesData[featureName]['integrations'] && freshsalesData[featureName]['integration-price']) ? (freshsalesData[featureName]['integration-price']) : 0;
    let integrationType = isIntegration ? freshsalesData[featureName]['addonType'] : '';

    if (isIntegration && integrationType !== '') {
      if (_hasClassActive) {
        _fsIntegrationTypes.push(integrationType);
      } else {
        _fsIntegrationTypes.splice(_fsIntegrationTypes.indexOf(integrationType), 1);
      }
    }
    let isIntegratedAlready = _fsIntegrationTypes.reduce(function (prev, current) { if (current === integrationType) prev = prev + 1; return prev; }, 0);

    if (isIntegration) {
      // Check for Integration count
      _fsIntegrationLength = _hasClassActive ? (isIntegratedAlready <= 1 ? (_fsIntegrationLength + 1) : _fsIntegrationLength) : (isIntegratedAlready <= 0 ? (_fsIntegrationLength - 1) : _fsIntegrationLength);
      jQuery('.fs-integ-numb').html(_fsIntegrationLength);
    }
  };

  const featureAbsent = (feature) => {
    jQuery(`.feature-comparison-widget[data-feature="${feature}"]`).addClass('disabled');
  };

  const modifyUIValues = () => {
    jQuery.grep(_fsFeaturesKeys, function (key) {
      if (jQuery.inArray(key, _competitorFeaturesKeys) === -1) featureAbsent(key);
    });
    pricingOutput('fs-numb', mathMax(_fsPricing));
    pricingOutput('vs-numb', mathMax(_competitorPricing));
  };

  // function to get the selected feature's plan value
  const pricingOutput = (className, largestValue) => {
    let _pricingOutput = (largestValue) * (agentCount) || 0;
    jQuery('.' + className).html(_pricingOutput);
  };

  // Compute Integration Price for Competitor
  const competitorIntegrationPrice = (competitorData, featureName, _hasClassActive) => {
    let isIntegration = competitorData[featureName]['integrations'] === true;
    let integrationPrice = competitorData[featureName]['integration-price'];
    let integrationCount = competitorData[featureName]['integration-user-count'] !== '' ? competitorData[featureName]['integration-user-count'] : 1;
    let integrationType = isIntegration ? competitorData[featureName]['addonType'] : '';

    // Push the existing integrations types into an array
    if (isIntegration && integrationType !== '') {
      if (_hasClassActive) {
        _competitorIntegrationTypes.push(integrationType);
      } else {
        _competitorIntegrationTypes.splice(_competitorIntegrationTypes.indexOf(integrationType), 1);
      }
    }

    let isIntegratedAlready = _competitorIntegrationTypes.reduce(function (prev, current) { if (current === integrationType) prev = prev + 1; return prev; }, 0);

    if (isIntegration) {
      // Check for Integration count
      _integrationLength = _hasClassActive ? (isIntegratedAlready <= 1 ? (_integrationLength + 1) : _integrationLength) : (isIntegratedAlready <= 0 ? (_integrationLength - 1) : _integrationLength);
      jQuery('.vs-integ-numb').html(_integrationLength);
    }

    // compute integration price
    if (_hasClassActive) {
      _totalIntegrationPrice = _totalIntegrationPrice + (isIntegratedAlready <= 1 ? (isIntegration ? integrationPrice * integrationCount : 0) : 0);
    } else {
      _totalIntegrationPrice = _totalIntegrationPrice - (isIntegratedAlready <= 0 ? (isIntegration ? integrationPrice * integrationCount : 0) : 0);
    }
    return _totalIntegrationPrice;
  };

  jQuery.getJSON('/static-assets/js/data/comparison-pricing.json', (result) => {
    _comparisonRates = result;
    initUI();
    freshsalesPlan.push(_comparisonRates['freshsales']);
    let _sproutPlan = filterByProperty(freshsalesPlan);
    jQuery.each(_sproutPlan, function (index, value) {
      jQuery(`.feature-comparison-widget[data-feature="${value}"]`).addClass('active');
      computePrice(true, value, true);
    });

    _fsFeaturesKeys = Object.keys(_comparisonRates['freshsales']);
    _competitorFeaturesKeys = Object.keys(_comparisonRates[_competitorName]);

    // Display UI Values
    modifyUIValues();
    jQuery('.vs-numb').html((mathMax(_competitorPricing) * agentCount) + _totalIntegrationPrice);
  });
};

const pricingCompare = {
  pricingCompareLoader
};

export { pricingCompare };
